import { render } from "./HistorialPagosProveedorModal.vue?vue&type=template&id=c3634644&scoped=true"
import script from "./HistorialPagosProveedorModal.vue?vue&type=script&lang=js"
export * from "./HistorialPagosProveedorModal.vue?vue&type=script&lang=js"

import "./HistorialPagosProveedorModal.vue?vue&type=style&index=0&id=c3634644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3634644"]])

export default __exports__